export function initSearchOverlay() {
  const searchQueryText = document.querySelector('.po-search-query__query');
  const editButton = document.querySelector('.po-search-query__action');
  const overlay = document.querySelector('.po-search-query__overlay');

  if (!overlay || !editButton) return;

  const overlayInput = overlay.querySelector('.po-search-query__overlay-input');
  const overlaySubmit = overlay.querySelector(
    '.po-search-query__overlay-submit'
  );
  const overlayClose = overlay.querySelector('.po-search-query__overlay-close');

  editButton.addEventListener('click', () => {
    overlayInput.value = searchQueryText.textContent.trim();
    overlay.classList.add('active');
    overlayInput.focus();
  });

  overlayClose.addEventListener('click', () => {
    overlay.classList.remove('active');
  });

  overlaySubmit.addEventListener('click', () => {
    const newQuery = overlayInput.value.trim();
    if (!newQuery) return;
    searchQueryText.textContent = newQuery;
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('s', newQuery);
    window.location.href = newUrl;
  });

  overlayInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      overlaySubmit.click();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.classList.contains('active')) {
      overlay.classList.remove('active');
    }
  });
}
